var _path, _path2, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleRemovalsAdvance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59 15v41c0 1.66-1.34 3-3 3h-52c-1.66 0-3-1.34-3-3v-41l1-2h56z",
    fill: "#ebf0f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59 9v6h-58v-6c0-1.66 1.34-3 3-3h52c1.66 0 3 1.34 3 3z",
    fill: "#e83a47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#2f3f56",
    height: 10,
    rx: 2.5,
    width: 5,
    x: 12,
    y: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#2f3f56",
    height: 10,
    rx: 2.5,
    transform: "matrix(-1 0 0 -1 91 12)",
    width: 5,
    x: 43,
    y: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1199ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.67 47.52c0 .53-.2 1.05-.6 1.46-3.17 3.21-7.46 5.02-12.07 5.02-8.78 0-16.04-6.71-16.91-15.27l-.27.27c-.78.78-2.04.78-2.82 0-.39-.39-.58-.9-.58-1.41s.19-1.02.58-1.41l3.6-3.61c.77-.77 2.03-.77 2.8 0l3.6 3.61c.78.78.78 2.04 0 2.82-.39.39-.9.59-1.41.59s-1.02-.2-1.41-.58l-.03-.03c.95 6.23 6.35 11.02 12.85 11.02 3.54 0 6.83-1.4 9.26-3.87.7-.71 1.79-.84 2.59-.24.54.41.82 1.02.82 1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.58 36.41c0 .51-.19 1.02-.58 1.41l-3.6 3.61c-.77.77-2.03.77-2.8 0l-3.6-3.61c-.78-.78-.78-2.04 0-2.82.39-.39.9-.59 1.41-.59s1.02.2 1.41.58l.03.03c-.95-6.23-6.35-11.02-12.85-11.02-3.54 0-6.83 1.4-9.26 3.87-.7.71-1.79.84-2.59.24-.54-.41-.82-1.02-.82-1.63 0-.53.2-1.05.6-1.46 3.17-3.21 7.46-5.02 12.07-5.02 8.78 0 16.04 6.71 16.91 15.27l.27-.27c.78-.78 2.04-.78 2.82 0 .39.39.58.9.58 1.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleRemovalsAdvance);
export default __webpack_public_path__ + "static/media/schedule-removals-advance.e812176a7a159d721f6b7e8412b661b2.svg";
export { ForwardRef as ReactComponent };